import { render, staticRenderFns } from "./BiddingFOB.vue?vue&type=template&id=1bb08f41&"
import script from "./BiddingFOB.vue?vue&type=script&lang=js&"
export * from "./BiddingFOB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports